import { useState } from "react";
import { Box, Grid, Typography } from "@mui/material";
import hostel_img_1 from "../../assets/images/facilities/Hostel/hoset_img_1.jpg";
import hostel_img_2 from "../../assets/images/facilities/Hostel/hoset_img_2.jpg";
import hostel_img_3 from "../../assets/images/facilities/Hostel/hoset_img_3.jpg";
import ImageSlider from "../../components/ImageSlider";
import TransitionsModal from "../../components/modal/modal";
import { ZoomInRounded } from "@mui/icons-material";
import ContentLayout from "../../components/ContentLayout";
import ImageSlideshow from "../../components/ImageSlideShow";

type ImageType = {
  src: string;
  alt: string;
};

type InfraObect = {
  name: string;
  img: Array<ImageType>;
};

const hostelData: Array<InfraObect> = [
  {
    name: "Hostel",
    img: [
      { src: hostel_img_1, alt: "l_img_1" },
      { src: hostel_img_2, alt: "l_img_1" },
      { src: hostel_img_3, alt: "l_img_1" },
    ],
  },
];

const Hostel = () => {
  const [open, setOpen] = useState(false);
  const [title, setTitle] = useState("");
  const [sliderImages, setSliderImages] = useState<Array<ImageType>>();

  return (
    <>
      <ContentLayout>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Box sx={{ position: "relative" }} >
              <ImageSlideshow
                sx={{}}
                images={hostelData[0]?.img as Array<ImageType>}
                showCaption={false} showCount={false} />
              <Box
                sx={{
                  position: "absolute" as "absolute",
                  top: "50%",
                  left: "50%",
                  transform: "translate(-50%, -50%)",
                }}
                onClick={() => {
                  setTitle(hostelData[0]?.name);
                  setSliderImages(hostelData[0]?.img);
                  setOpen(true);
                } }
              >
                <ZoomInRounded
                  sx={{
                    color: "#fdd025",
                    zIndex: 99,
                    fontSize: "4rem",
                    "&:hover": {
                      fontSize: "6rem",
                    },
                  }} />
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <Typography  variant="body2" textAlign="justify" mb={2} fontSize={"1rem"}>
              Modern College of Physiotherapy offers comfortable and secure hostel accommodations for both male and female students.
              The hostels are designed to provide a conducive environment for academic pursuits and personal growth.
              Each room is well-ventilated, ensuring a fresh and healthy atmosphere.
              A dedicated mess facility caters to the nutritional needs of the students, providing wholesome meals.
              The hostels operate on a 24/7 basis with stringent security measures in place to safeguard the well-being of residents.
              A dedicated housekeeping staff maintains cleanliness and hygiene, while a vigilant warden is always available to address student concerns and oversee the overall management of the hostel. 
            </Typography>
          </Grid>
        </Grid>
      </ContentLayout>
      
      {sliderImages && (
        <TransitionsModal
          open={open}
          setOpen={setOpen}
          title={title}
          children={<Grid item xs={12} margin={"auto"}>
            <Box sx={{ width: "75%", margin: "auto" }}>
              <ImageSlider images={sliderImages} />
            </Box>
          </Grid>} />
      )}
    </>
  );
};

export default Hostel;
